import {axiosRequest} from '@src/helpers';
import {ENV} from "@environments/environment";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY} = ENV

export const getBasicConfig = async () => {
  return await axiosRequest(`${API_URL}/get-basic-config`, {
    method: 'GET'
  });
};

export const getBrandInfo = async (brand: any) => {
  return await axiosRequest(`${API_URL}/get-b2c-brand-footer?brand=${brand}`, {
    method: 'GET'
  });
};

export const getProcessInfo = async (order: any, process: any) => {
  return await axiosRequest(`${API_URL}/get-b2c-process-info?order=${order}&process_id=${process}`, {
    method: 'GET'
  });
};

export const getProcessEco = async (order: any, process: any) => {
  return await axiosRequest(`${API_URL}/get-b2c-process-eco?order=${order}&process_id=${process}`, {
    method: 'GET'
  });
};

export const getProcessMedia = async (order: any, process: any) => {
  return await axiosRequest(`${API_URL}/get-b2c-process-media?order=${order}&process_id=${process}`, {
    method: 'GET'
  });
};

export const getServerYear = async () => {
  return {data: 2021};
  // return await axiosRequest(`${API_URL}/get-year`, {
  //   method: 'GET',
  // });
};

export const getCSS = async (brand: string) => {
  return await axiosRequest(`${API_URL}/get-b2c-brand-css?brand=${brand}`, {
    method: 'GET',
  });
};

export const getRedirect = async (code: string) => {
  return await axiosRequest(`${API_URL}/get-encrypted-url-by-shortcode?shortcode=${code}`, {
    method: 'GET',
  });
};

export const getInputProducts = async (uid: string) => {
  return await axiosRequest(`${API_URL}/orders/null/processes/${uid}/input-products`, {
    method: 'GET',
  });
};
